// /**
//  * Orders - list
//  */

// React
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

// UI
import theme from '../../theme';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
  lighten,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
  Button,
  Checkbox,
  Typography,
  Tooltip,
  Toolbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Select,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiClose,
  mdiFileDocumentOutline,
  mdiPackageVariantClosed,
  mdiPencilOutline,
  mdiHistory,
  mdiChevronDown,
  mdiChevronUp, mdiPlusBoxMultiple
} from '@mdi/js';

// Components
import Can from '../../components/Can';

// Rules
import {
  rulesAdminChangeOrderStatus,
  rulesOrderStatus,
} from '../../utils/rulesOrderStatus';

// Helper
// import {
//   translateOrderStatus,
//   checkMatchMedia,
//   translateSendDeliveryType,translateCodStatus
// } from '../../utils/helpers';
import { translate, checkMatchMedia } from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Order, Status } from './interfaces';
import showOrderTplType from '../../utils/temporaryConditions/showOrderTplType';
import showDeliveryType from '../../utils/temporaryConditions/showDeliveryType';
import RonadIcons from '../../components/iconComponent';

type Data = Order;
type Props = {
  data: any;
  handleConfirmCanceleBox: (id: number) => void;
  changeStatusOrderWhitId: any;
  handleOpenConfirmUpdateState: any;
};
type Ord = 'asc' | 'desc';

interface HeadCell {
  id: keyof Data;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
  numSelected: number;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      textAlign: 'left',
      padding: '10px 0',
      backgroundColor: '#d3d6e8 !important',
      color: '#212121',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      textAlign: 'left',
      padding: '10px 10px',
      borderRadius: '0',
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  })
)(TableCell);
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
      border: "1px solid #2F485833",
      borderRadius: "4px",
      boxShadow: "8px 8px 21px -5px rgba(0,0,0,0.27)"
    },
    hover: {
      '&:hover': {
        backgroundColor: '#F8F9FA !important',
      },
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    columnText: {
      padding: '0 10px',
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 750,
      borderRadius: '0',
      boxShadow: "-4px 4px 12px 5px rgba(0,0,0,0.06)"
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    badge: {
      backgroundColor: "#fff5e9",
      borderRadius: "30px",
      color: "#ec6839",
      fontSize: "12px",
      border: "1px solid #ec6839",
      padding: "6px 12px"
    }
  })
);

const useToolbarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: 'space-between',
    },
    highlight:
      theme.palette.type === 'light'
        ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
        : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
    title: {
      // flex: '1 1 100%',
    },
  })
);

interface EnhancedTableToolbarProps {
  numSelected: number;
  setOpenChangeStatus: any;
  selected: any;
  data: any;
}

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const classes = useToolbarStyles();
  const [openAlertWarning, setOpenAlertWarning] = useState(false as boolean);
  const { numSelected, selected, data } = props;

  const handleClickChangeStatus = () => {
    const selectedData = data.filter(
      (item: any) => selected.indexOf(item.id) > -1
    );

    if (!checkStatus(selectedData)) {
      setOpenAlertWarning(true);
    } else {
      props.setOpenChangeStatus(true);
    }
  };

  const checkStatus = (data: any) => {
    let sameStatus = true;
    data?.map((item: any) => {
      if (item?.status !== data[0]?.status) {
        return (sameStatus = false);
      }
      return item;
    });
    return sameStatus;
  };

  return (
    <>
      {numSelected > 0 && (
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography
              className={classes.title}
              color="inherit"
              variant="subtitle1"
              component="div"
            >
              {numSelected} انتخاب
            </Typography>
          ) : (
            <Typography
              className={classes.title}
              variant="h6"
              id="tableTitle"
              component="div"
            />
          )}
          {numSelected > 0 ? (
            <Tooltip title="تغییر وضعیت">
              <Button
                size="small"
                variant="contained"
                onClick={handleClickChangeStatus}
                color="secondary"
              >
                تغییر وضعیت
              </Button>
            </Tooltip>
          ) : (
            <></>
            // <Tooltip title="Filter list">
            //   <IconButton aria-label="filter list">
            //     FilterIcon
            //   </IconButton>
            // </Tooltip>
          )}
        </Toolbar>
      )}
      <Dialog
        fullWidth
        open={openAlertWarning}
        onClose={() => setOpenAlertWarning(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>امکان تغییر وضعیت سفارش وجود ندارد </DialogTitle>
        <DialogContent>
          وضعیت سفارش آیتم‌های انتخاب شده باید یکی باشد
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenAlertWarning(false)}
            variant="contained"
            color="primary"
          >
            {'متوجه شدم'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const {
    order,
    orderBy,
    onRequestSort
  } = props;
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };
  let headCells: HeadCell[] = [];

  Can({
    role: authContext.user.role,
    perform: 'orders:list:centerName',
    yes: () => {
      headCells = [
        {
          id: 'customerName',
          label: 'نام سفارش‌دهنده',
        },
        { id: 'id', label: 'کد سفارش' },
        { id: 'trackingCode', label: 'کد پیگیری' },
        { id: 'deliveryType', label: 'نوع ارسال' },
        { id: 'centerName', label: 'مرکز سفارش' },
        {
          id: 'deliveryDate',
          label: 'زمان تحویل',
        },
        { id: 'status', label: 'وضعیت سفارش' },
        { id: 'codValue', label: 'شیوه پرداخت' },
      ];
    },
    no: () => {
      headCells = [
        {
          id: 'customerName',
          label: 'نام گیرنده',
        },
        { id: 'id', label: 'شناسه سفارش' },
        { id: 'trackingCode', label: 'کد پیگیری' },
        { id: 'deliveryType', label: ' نوع سفارش' },
        { id: 'orderTPLType', label: 'ناوگان حمل' },
        {
          id: 'deliveryDate',
          label: 'زمان تحویل',
        },
        { id: 'status', label: 'وضعیت سفارش' },
        { id: 'codValue', label: 'شیوه پرداخت' },
        { id: 'origin', label: 'مبدا ایجاد' },
      ];
    },
  });

  return (
    <TableHead>
      <TableRow style={{ borderRadius: '0' }}>
        <StyledTableCell padding="checkbox">
          {/* <Can
            role={authContext.user.role}
            perform="orders:changeOrderStatus"
            yes={() => (
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={rowCount > 0 && numSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{ 'aria-label': 'select all desserts' }}
                style={{ color: '#fff' }}
              />
            )}
          /> */}
        </StyledTableCell>
        {headCells.map(headCell => (
          <StyledTableCell
            key={headCell.id}
            align="center"
            sortDirection={orderBy === headCell.id ? order : false}
            data-cy={headCell.id}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              classes={{
                // Override with the active class if this is the selected column or inactive otherwise
                icon:
                  orderBy === headCell.id
                    ? classes.activeSortIcon
                    : classes.inactiveSortIcon,
              }}
              IconComponent={() => (
                <Icon
                  path={
                    orderBy === headCell.id && order === 'desc'
                      ? mdiChevronDown
                      : mdiChevronUp
                  }
                  size={0.7}
                  className={
                    orderBy === headCell.id
                      ? classes.activeSortIcon
                      : classes.inactiveSortIcon
                  }
                />
              )}
            >
              <span className={classes.columnText}>{headCell.label}</span>
            </TableSortLabel>
          </StyledTableCell>
        ))}
        <StyledTableCell />
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();

  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');
  const [selected, setSelected] = React.useState<string[]>([]);
  const [valueStatus, setValueStatus] = React.useState('');
  const [openChangeStatus, setOpenChangeStatus] = React.useState(false);

  const handleChangeValueStatus = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValueStatus((event.target as HTMLInputElement).value);
  };
  const { handleConfirmCanceleBox: handleClickOpen } = props;
  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const changeStatusOrder = () => {
    props.changeStatusOrderWhitId({
      ids: selected,
      status: `${valueStatus}`,
      description: null,
    });
  };

  const isSelected = (id: string) => {
    return props.selectedItems?.indexOf(id) !== -1;
  };

  return (
    <div className={classes.root}>
      <EnhancedTableToolbar
        numSelected={selected.length}
        setOpenChangeStatus={setOpenChangeStatus}
        selected={selected}
        data={props.data}
      />
      <div>
        <TableContainer className={classes.container}>
          <Table
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={props.data.length}
              numSelected={props.selectedItems.length}
            />

            <TableBody>
              {stableSort(props.data, getComparator(order, orderBy))
                .slice()
                .map((row: any, index: number) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow
                      className={classes.hover}
                      key={index}
                      // style={{
                      //   backgroundColor:
                      //     !row.exists && row.status === 'ORDERED'
                      //       ? '#f7d28b'
                      //       : !row.exists && row.status === 'SUPPLYING'
                      //         ? '#FFFF8F'
                      //         : 'white',
                      // }}
                      role="checkbox"
                      aria-checked={isSelected(row.id)}
                      tabIndex={-1}
                      selected={isSelected(row.id)}
                    >
                      <StyledTableCell padding="checkbox">

                        <Checkbox
                          key={index}
                          onClick={event =>
                            props.handleSelect(row.id)
                          }
                          checked={isSelected(row.id)}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />

                      </StyledTableCell>
                      <StyledTableCell id={labelId} scope="row" align="center">
                        {row.customerName}
                      </StyledTableCell>
                      <StyledTableCell
                        // style={{textAlign: 'center', paddingLeft: '25px'}}
                        data-cy="id"
                      >
                        {row.id}
                        {row.warehouseType == 'MULTI' && (
                          <span style={{ padding: '5px' }}>
                            <Icon
                              color={theme.palette.green.main}
                              path={mdiPlusBoxMultiple}
                              size={1}
                            />
                          </span>
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="center" data-cy="trackingCode">
                        {row.trackingCode}
                      </StyledTableCell>
                      <StyledTableCell align="center" data-cy="deliveryType">
                        {showDeliveryType(row.deliveryType)}
                        &nbsp;
                        {row.deliveryLocationType === "IN_RONAD" &&
                          <span>
                            (تحویل درب انبار)
                          </span>
                        }

                      </StyledTableCell>
                      <StyledTableCell align="center" data-cy="deliveryType">
                        {showOrderTplType(row.deliveryType, row.orderTPLType)}
                      </StyledTableCell>
                      <Can
                        role={authContext.user.role}
                        perform="orders:list:centerName"
                        yes={() => (
                          <StyledTableCell align="center">
                            {row.centerName}
                          </StyledTableCell>
                        )}
                      />

                      <StyledTableCell align="center">
                        <span>
                          {jMoment(row.deliveryDate, 'YYYY/M/D')
                            .locale('fa')
                            .format('jYY/jMM/jDD')}
                        </span>
                        &nbsp; &nbsp;- &nbsp; &nbsp;
                        <span>
                          {`${jMoment(row.deliveryStartTime, 'HH:mm:ss')
                            .locale('fa')
                            .format('HH')}
                        `}
                          {`تا ${jMoment(row.deliveryEndTime, 'HH:mm:ss')
                            .locale('fa')
                            .format('HH')}`}
                        </span>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Can
                          role={authContext.user.role}
                          perform="orders:changeOrderStatus"
                          yes={() => (
                            <FormControl style={{ width: '100%' }}>
                              <Icon
                                path={mdiPencilOutline}
                                size={1}
                                className={classes.changStatusIcon}
                              />
                              <Select
                                className={classes.changStatusBox}
                                fullWidth
                                name={`status${index}`}
                                multiple
                                id={row.id}
                                value={[{}]}
                                IconComponent={() => null}
                                renderValue={() => (
                                  <span
                                    className={classes.renderValue}
                                    data-cy="status"
                                  >
                                    {translate(row.status, 'order')}
                                  </span>
                                )}
                              >
                                <RadioGroup
                                  className={classes.radioGroup}
                                  aria-label={`status${index}`}
                                  name={`status${index}`}
                                  value={'item'}
                                  onChange={(
                                    e: React.ChangeEvent<{ value: unknown }>
                                  ) =>
                                    props.handleOpenConfirmUpdateState({
                                      id: row.id,
                                      body: `${e.target.value}`,
                                    })
                                  }
                                >
                                  {rulesOrderStatus[row.status]?.map(
                                    (item: any, index: number) => (
                                      <FormControlLabel
                                        className={classes.radioGroupItem}
                                        key={index}
                                        checked={row.status === item}
                                        value={item}
                                        disabled={
                                          rulesAdminChangeOrderStatus[
                                            authContext.user.role
                                          ].indexOf(item) === -1
                                        }
                                        control={<Radio />}
                                        label={translate(item, 'order')}
                                      />
                                    )
                                  )}
                                </RadioGroup>
                              </Select>
                            </FormControl>
                          )}
                          no={() => (
                            <span className={row.status === 'SUPPLYING' && classes.badge}>{translate(row.status, 'order')}</span>
                          )}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {translate(row.paymentType, 'cod')}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {translate(row.origin)}
                      </StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'left' }}>
                        <div>
                          <Link to={`/orders/${row.id}`}>
                            {/* <IconButton
                              aria-label="details"
                              size="small"
                              title="جزئیات سفارش"
                              data-cy="details"
                            >
                              <Icon
                                path={mdiFileDocumentOutline}
                                size={1}
                                color={theme.palette.green.main}
                              />
                            </IconButton> */}
                            <RonadIcons name='detailIcon' title="جزئیات سفارش"/>
                          </Link>
                          {(row.status === 'ORDERED' ||
                            row.status === 'SUPPLYING') && row.orderType !== "FROM_CENTER" && (
                              <Can
                                role={authContext.user.role}
                                perform="orders:edit"
                                yes={() => (
                                  <Link to={`/edit-order/${row.id}`}>
                                    {/* <IconButton
                                      size="small"
                                      title="ویرایش سفارش"
                                      data-cy="edit"
                                    >
                                      <Icon
                                        color={theme.palette.blue.main}
                                        path={mdiPencilOutline}
                                        size={1}
                                      />
                                    </IconButton> */}
                                    <RonadIcons name='editIcon' title="ویرایش سفارش"/>
                                  </Link>
                                )}
                              />
                            )}
                          {row.orderType == "FROM_CENTER" && (
                            <Can
                              role={authContext.user.role}
                              perform="orders:edit"
                              yes={() => (
                                <Link to={`/crossdock/${row.id}`}>
                                  {/* <IconButton
                                    size="small"
                                    title="ویرایش سفارش"
                                    data-cy="edit"
                                  >
                                    <Icon
                                      color={theme.palette.blue.main}
                                      path={mdiPencilOutline}
                                      size={1}
                                    />
                                  </IconButton> */}
                                  <RonadIcons name='editIcon' title="ویرایش سفارش"/>
                                </Link>
                              )}
                            />
                          )}
                          <Can
                            role={authContext.user.role}
                            perform="orders:byBundle"
                            yes={() =>
                              row.status !== 'ORDERED' && row.status ? (
                                <Link to={`/bundles/${row.bundleId}`}>
                                  <IconButton
                                    aria-label="bundle"
                                    size="small"
                                    title="نمایش سفارش در بسته "
                                    color="secondary"
                                    data-cy="bundle"
                                  >
                                    <Icon
                                      path={mdiPackageVariantClosed}
                                      size={1}
                                      color={theme.palette.blue.main}
                                    />
                                  </IconButton>
                                </Link>
                              ) : (
                                <IconButton
                                  aria-label="bundle"
                                  size="small"
                                  title="بسته‌بندی نشده"
                                  disabled
                                  color="default"
                                  style={{ pointerEvents: 'fill' }}
                                  data-cy="bundle"
                                >
                                  <Icon
                                    path={mdiPackageVariantClosed}
                                    size={1}
                                  />
                                </IconButton>
                              )
                            }
                          />
                          {/* <Can
                            role={authContext.user.role}
                            perform="orders:history"
                            yes={() => (
                              <Link to={`/orders/${row.id}/allLogs`}>
                                <IconButton
                                  size="small"
                                  title="تاریخچه سفارش"
                                  data-cy="history"
                                >
                                  <Icon path={mdiHistory} size={1} />
                                </IconButton>
                              </Link>
                            )}
                          /> */}
                          <Can
                            role={authContext.user.role}
                            perform="orders:cancelOrders"
                            yes={() =>
                              (row.orderType !== "FROM_CENTER" || (row.orderType === "FROM_CENTER" && row.status === 'ORDERED')) && (
                                // <IconButton
                                //   aria-label="cancele"
                                //   title={
                                //     row.status === 'CANCELLED'
                                //       ? 'لغو شده'
                                //       : 'لغو سفارش'
                                //   }
                                //   size="small"
                                //   style={{ pointerEvents: 'fill' }}
                                //   disabled={
                                //     row.status === 'DELIVERED' ||
                                //     row.status === 'ARRIVED' ||
                                //     row.status === 'DELIVERED_TO_POST' ||
                                //     row.status === 'LOADED' ||
                                //     row.status === 'CANCELLED' ||
                                //     row.status === 'NOT_DELIVERED'
                                //   }
                                //   onClick={() => handleClickOpen(row.id)}
                                //   data-cy="cancel"
                                // >
                                //   <Icon
                                //     path={mdiClose}
                                //     size={1}
                                //     color={
                                //       row.status !== 'CANCELLED' && row.status !== 'NOT_DELIVERED'
                                //         ? theme.palette.error.main
                                //         : theme.palette.gray.main
                                //     }
                                //   />
                                // </IconButton>
                                <RonadIcons name='timesIcon' title={
                                  row.status === 'CANCELLED'
                                    ? 'لغو شده'
                                    : 'لغو سفارش'
                                }/>
                              )}
                          />
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Dialog
        fullWidth
        open={openChangeStatus}
        onClose={() => setOpenChangeStatus(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle> تغییر وضعیت کلی سفارش</DialogTitle>
        <DialogContent>
          <FormControl component="fieldset">
            <FormLabel component="legend">وضعیت</FormLabel>
            <RadioGroup
              aria-label="status"
              name="Status"
              value={valueStatus}
              onChange={handleChangeValueStatus}
            >
              {rulesOrderStatus[
                props.data.find((data: any) => data.id === selected[0])?.status
              ]?.map((item: Status, index: number) => (
                <FormControlLabel
                  value={item}
                  key={index}
                  control={<Radio key={index} />}
                  label={translate(item, 'order')}
                  disabled={
                    rulesAdminChangeOrderStatus[authContext.user.role].indexOf(
                      item
                    ) === -1
                  }
                />
              ))}
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => setOpenChangeStatus(false)}
            variant="contained"
            color="primary"
          >
            {'خیر'}
          </Button>

          <Button
            onClick={changeStatusOrder}
            color="primary"
            variant="outlined"
          >
            {'تغییر وضعیت'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
